import { render, staticRenderFns } from "./eliminacionProductos.vue?vue&type=template&id=078af413&scoped=true&"
import script from "./eliminacionProductos.vue?vue&type=script&lang=js&"
export * from "./eliminacionProductos.vue?vue&type=script&lang=js&"
import style0 from "./eliminacionProductos.vue?vue&type=style&index=0&id=078af413&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078af413",
  null
  
)

export default component.exports